import EditIcon from '@mui/icons-material/Edit';
import { Button, Stack } from '@mui/material';
import ColoredAvatar from 'core/components/ColoredAvatar';
import { getFullName } from 'core/utils/commonUtils';
import PageHeaderBackLink from 'layout/pages/PageHeaderBackLink';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { isNil } from 'lodash';
import { useNavigate } from 'react-router-dom';
import type { User } from 'models/user/user';
import type { FC } from 'react';

const UserViewPageHeader: FC<UserPageHeaderProps> = ({ user }) => {
  const navigate = useNavigate();

  const toEdit = (): void => {
    navigate('edit');
  };

  return (
    <PageHeaderWrapper>
      <Stack spacing={2}>
        <PageHeaderBackLink to='/users' name='Сотрудники' />
        <Stack direction={'row'} spacing={2} sx={{ alignItems: 'center' }}>
          <ColoredAvatar alt={user?.surname}>{user?.surname?.[0]}</ColoredAvatar>
          <PageHeaderText text={!isNil(user) ? getFullName(user) : 'Сотрудник'} />
        </Stack>
      </Stack>
      <Button variant='contained' onClick={toEdit} startIcon={<EditIcon />}>
        Редактировать
      </Button>
    </PageHeaderWrapper>
  );
};

export interface UserPageHeaderProps {
  user?: User;
}

export default UserViewPageHeader;
